<script setup lang="ts">
import BottomSheetDialog from '@/components/Utilities/BottomSheetDialog.vue';
import type { Question, TestType } from '@/types/TestReview';
import TestReviewPerformance from '@/components/Student/TestReview/TestReviewPerformance.vue';
import type { FlightSchoolCourseStudent } from '@/types/FlightSchoolStudent';
import type FlightSchool from '@/types/FlightSchool';
import type FlightSchoolCourse from '@/types/FlightSchoolCourse';
import type { ExamPerformanceTypes } from '@/types/Performance';

defineProps<{
    questions: Question[];
    testType: TestType,
    school: FlightSchool | null,
    course: FlightSchoolCourse | null,
    student: FlightSchoolCourseStudent | null,
    exam: ExamPerformanceTypes,
}>();

</script>
<template>
    <BottomSheetDialog
        full-width
        title="Performance"
        :enable-clear-all-btn="false"
        :enable-action-btns="false"
    >
        <TestReviewPerformance
            :questions="questions"
            :test-type="testType"
            :school="school"
            :course="course"
            :student="student"
            :exam="exam"
            :is-visible="true"
        />
    </BottomSheetDialog>
</template>
<style>
</style>
